import React from 'react';

import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';

import { CommonSideNavItemProps, DefaultItemType } from '@townsquare/griffin-navigation/types';
import { matchRoute } from '@townsquare/router/primitives/match-route';
import { useQueryParams } from '@townsquare/router/use-query-params';
import { useRouter } from '@townsquare/router/useRouter';
import { getScreenFromStringOrDefault } from '@townsquare/teams-settings-view/screen-config';
import { type ScreenType } from '@townsquare/teams-settings-view/screen-config/types';

export type SettingsMenuItemProps = CommonSideNavItemProps & { item: DefaultItemType } & {
	matchingDirectoryScreens: ScreenType[];
};

export const SettingsMenuItem = ({
	onClick,
	item,
	matchingDirectoryScreens,
}: SettingsMenuItemProps): React.JSX.Element => {
	const [routerStore] = useRouter();
	const queryParams = useQueryParams();
	const isSelected =
		'screen' in queryParams
			? matchingDirectoryScreens.includes(getScreenFromStringOrDefault(queryParams['screen']))
			: Boolean(matchRoute(item.matches, routerStore.location.pathname, undefined));

	return (
		<LinkMenuItem
			key={item.analyticsSubject}
			onClick={e => onClick(item, e)}
			isSelected={isSelected}
			href={item.path}
			testId={item.testId}
		>
			{item.name}
		</LinkMenuItem>
	);
};
